import Tiles from '../components/multi-column-tiles';
// We had to remove the register functionality from slate as it causes conflicts with sections anywhere.
const sections = document.querySelectorAll('[data-section-type="multi-column-tiles"]');
if (sections.length > 0) {
    [...sections].forEach((section) => {
        const sectionId = section.dataset.sectionId;
        const slides = parseInt(section.dataset.tiles, 10);
        if (slides > 1) {
            const swiperContainer = section.querySelector('[data-swiper-container]');
            const swiperNext = `[data-section-id="${sectionId}"] .swiper-button-next`;
            const swiperPrev = `[data-section-id="${sectionId}"] .swiper-button-prev`;
            const tiles = new Tiles(swiperContainer, slides, swiperNext, swiperPrev);
        }
    });
}
